// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609281934/js/" + chunkId + "." + {"44":"d8ea64b6","225":"e48120ed","481":"8574e214","486":"9ff9b7bc","770":"1d2d3277"}[chunkId] + ".0.3998415319338897.chunk.js";
};